import classNames from 'classnames';
import { dateStringFormatter } from '~/features/utils';
import { ContractDetail } from '../types';

interface Props {
  contract: ContractDetail;
}

interface TimelineEvent {
  label: string;
  date: string | null;
  isPast: boolean;
}

const buildTimelineEvents = (contract: ContractDetail): TimelineEvent[] => {
  const now = new Date();
  const events: TimelineEvent[] = [];

  const createdDate = contract.jobListing?.createdAt ?? null;
  if (createdDate) {
    events.push({
      label: 'Created',
      date: createdDate,
      isPast: true,
    });
  }

  if (contract.executedAt) {
    events.push({
      label: 'Activated',
      date: contract.executedAt,
      isPast: new Date(contract.executedAt) <= now,
    });
  }

  events.push({
    label: 'Start Date',
    date: contract.contractStartDate,
    isPast: new Date(contract.contractStartDate) <= now,
  });

  if (contract.contractEndDate) {
    events.push({
      label: 'End Date',
      date: contract.contractEndDate,
      isPast: new Date(contract.contractEndDate) <= now,
    });
  }

  if (contract.terminatedAt) {
    events.push({
      label: 'Terminated',
      date: contract.terminatedAt,
      isPast: true,
    });
  }

  return events;
};

export const ContractTimeline = ({ contract }: Props) => {
  const events = buildTimelineEvents(contract);

  return (
    <div className="mb-6">
      <h4 className="text-sm font-bold text-grey-50 mb-3">Timeline</h4>
      <div className="relative pl-6">
        <div className="absolute left-[5px] top-2 bottom-2 w-0.5 bg-grey-100" />
        {events.map((event) => (
          <div key={event.label} className="relative flex items-start mb-4 last:mb-0">
            <div
              className={classNames(
                'absolute -left-6 top-1 w-3 h-3 rounded-full border-2',
                event.isPast ? 'bg-success border-success' : 'bg-white border-grey-500'
              )}
            />
            <div>
              <p className="text-sm font-bold text-grey-50">{event.label}</p>
              <p className="text-xs text-grey-500">
                {event.date ? dateStringFormatter(event.date, 'STRING') : '—'}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
